import { render, staticRenderFns } from "./OrgAccount.vue?vue&type=template&id=089a7808&scoped=true"
import script from "./OrgAccount.vue?vue&type=script&lang=js"
export * from "./OrgAccount.vue?vue&type=script&lang=js"
import style0 from "./OrgAccount.vue?vue&type=style&index=0&id=089a7808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a7808",
  null
  
)

export default component.exports